module.exports = __webpack_public_path__ + "img/circle-green.ab0db549.svg";